import React from "react";
import { Link } from "react-router-dom";
import "./Donation.css";

class Donation extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const donationUrl =
      "https://securelb.imodules.com/s/699/bp19/interior.aspx?sid=699&gid=1&sitebuilder=1&pgid=961&cid=2272&bledit=1&dids=559.&appealcode=A3739sort=1";

    return (
      <div className="donation container">
        <div className="donation-content">
          <h2 className="donation-title">
            Support SelecTree and Urban Forestry
          </h2>

          <div className="donation-info-container">
            <div className="donation-intro">
              <p>Thank you for your interest in supporting SelecTree!</p>

              <p>
                By clicking the 'Donate Now' button below, you will be taken to
                the Cal Poly Giving page, which will process your donation
                securely.
              </p>

              <div className="donation-image-container">
                <img
                  src="/images/donation-sample.png"
                  alt="Cal Poly Giving Page Preview"
                  className="donation-image"
                />
                <span className="donation-image-caption">
                  Cal Poly Giving Page (Sample)
                </span>
              </div>

              <p className="donation-highlight">
                <strong>Cal Poly Plant Conservatory Fund</strong> is pre-filled
                as the destination of your donation. This fund supports:
              </p>

              <ul className="donation-benefits">
                <li>The Urban Forest Ecosystems Institute at Cal Poly</li>
                <li>Growing of new urban forest trees at the Conservatory</li>
                <li>
                  Cal Poly students that make SelecTree the awesome tool that it
                  is!
                </li>
              </ul>
            </div>

            <div className="donation-button-container">
              <a
                href={donationUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="donation-button"
              >
                DONATE NOW
              </a>
              <p className="donation-redirect-notice">
                (You will be redirected to Cal Poly's secure donation page)
              </p>
            </div>
          </div>

          <p className="donation-thank-you">
            Thank you for your interest in supporting SelecTree and the Urban
            Forest
          </p>

          <div className="donation-faq">
            <h2 className="donation-faq-title">Frequently Asked Questions</h2>

            <div className="faq-item">
              <h4>Is my donation tax-deductible?</h4>
              <p>
                Yes, your donation to the Cal Poly Plant Conservatory Fund is
                tax-deductible.
              </p>
            </div>
            <div className="faq-item">
              <h4>How will my donation be used?</h4>
              <p>
                Your donation supports the Urban Forest Ecosystems Institute,
                growing new urban forestry technologies, and student development
                at Cal Poly.
              </p>
            </div>
            <div className="faq-item">
              <h4>Will I receive a receipt?</h4>
              <p>
                Yes, Cal Poly will send you a receipt for your tax-deductible
                donation.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Donation;
